const CustomDrawerStyles = {
  drawer: {
    "& .MuiDrawer-paper": {
      width: "50%",
      "@media (max-width:768px)": { width: "100%" },
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #D8D8D8",
    width: "100%",
    padding: "20px",
  },
  title: {
    fontFamily: "Noto Sans",
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "22px",
    textAlign: "left",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    overflowY: "auto",
  },
};

export default CustomDrawerStyles;
